import Blue from "~/core";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

new Blue({
	name: 'Splash Page Animations',
	selector: ".splash-page",
	setup(splash) {
    const heroImage = splash.querySelector('.splash-hero__image');
    const reveals = splash.querySelectorAll('.splash-reveal');
    const dialog = splash.querySelector('.splash-header__menu');
    const menuToggle = splash.querySelector('.splash-header__menu-toggle');
    const gallery = splash.querySelector('.swiper--splash .swiper-container')
    const menuJumpLinks = splash.querySelectorAll('.splash-header__buttons .splash-header__link-jump')


    const revealAnimations = getGSAPRevealAnimations();

    initSlideTransition();

    // menu toggle
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('active');
      dialog.classList.toggle('active');
    });

    // close menu for jump links
    menuJumpLinks.forEach((menuJumpLink) =>{
      menuJumpLink.addEventListener('click', () => {
        menuToggle.classList.remove('active');
        dialog.classList.remove('active');
      });
    });

    // parallax heroImage
    gsap.to(heroImage, {
      scrollTrigger: {
        trigger: heroImage,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -15,
    });

    // clip path reveal scrolltrigger animation
    reveals.forEach((reveal) => {
      const revealType = reveal.dataset.reveal;
      const revealAnimation = revealAnimations[revealType];

      gsap.fromTo(
        reveal, 
        revealAnimation.from, {
        ...revealAnimation.to,
        scrollTrigger: {
          trigger: reveal,
          duration: 2,
          start: "top+=50px bottom"
        }
      });
    });
    
    // splash gallery
    function initSlideTransition() {
      let s;

      checkSwiper();

      function checkSwiper() {
        s = gallery?.swiper;

        if (s) {
          createHandler();
        } else {
          setTimeout(checkSwiper, 250);
        }
      }

      function createHandler() {
        s.on('beforeTransitionStart', onSlideChange);
      }

      function onSlideChange(swipe, speed) {
        const activeImg = s.slides[s.activeIndex].querySelector('img');
        
        gsap.fromTo(activeImg, {
          clipPath: "polygon(-85% 0%, 0% 0%, -15% 100%, -100% 100%)"
        }, {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          duration: speed / 1000,
        });
      }
    }
  }
});


function getGSAPRevealAnimations() {
  return {
    swipe: {
      from: { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
      to: { clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)" }
    },
    fade: {
      from: { opacity: 0 },
      to: { opacity: 1 }
    }
  }
}